import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoStatus from './ContentSolicitacaoFluxoStatus';

const SolicitacaoFluxoStatus = () => {
  return (
    <>
      <HeaderApp />
      <ContentSolicitacaoFluxoStatus />
      <Bottom />
    </>
  );
};

export default SolicitacaoFluxoStatus;
